import { getSearchParams } from "../../../utils/request";
import { api } from "../../api";

const invoicesApi = api.injectEndpoints({
  tagTypes: ["Invoices"],
  endpoints: (builder) => ({
    getInvoices: builder.query({
      query: ({ page = 1, limit = 20, ...rest }) => {
        const params = new URLSearchParams({
          legacy: false,
          page,
          limit,
          ...rest,
        });
        return `invoices?${params}`;
      },
      providesTags: (data) =>
        data?.invoices
          ? [
              ...data.invoices.map(({ _id }) => ({
                type: "Invoices",
                id: _id,
              })),
              { type: "Invoices", id: "LIST" },
            ]
          : [{ type: "Invoices", id: "LIST" }],
    }),
    addInvoice: builder.mutation({
      query(body) {
        return {
          url: "invoices",
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Invoices", id: "LIST" }, "Jobs"],
    }),
    getInvoice: builder.query({
      query: ({ id, ...rest }) => `invoices/${id}?${getSearchParams(rest)}`,
      transformResponse: (response) => response.data,
      providesTags: (_result, _error, data) => {
        // Some endpoints use `_id`, others rely on the mongoose virtual `id`.
        // Provide both shapes consistently so invalidation works reliably.
        const invoiceId = data?._id || data?.id;
        return invoiceId ? [{ type: "Invoices", id: invoiceId }] : [];
      },
    }),
    updateInvoice: builder.mutation({
      query({ id, data }) {
        return {
          url: `/invoices/${id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Invoices", id },
        { type: "Jobs", id: "LIST" },
      ],
    }),
    deleteInvoices: builder.mutation({
      query({ data }) {
        return {
          url: `/invoices`,
          method: "DELETE",
          body: data,
        };
      },
      invalidatesTags: (_result, _error, { data, jobs }) => {
        return [
          ...data.map((id) => ({
            type: "Invoices",
            id,
          })),
          ...jobs.map((id) => ({
            type: "Jobs",
            id,
          })),
        ];
      },
    }),
    sendInvoiceEmail: builder.mutation({
      query: ({ data, invoiceId }) => ({
        url: `/invoices/${invoiceId}/send-invoice`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (_result, _error, { invoiceId }) => [
        { type: "Invoices", id: "LIST" },
        { type: "Invoices", id: invoiceId },
      ],
    }),
    overrideExisting: false,
  }),
});

export const {
  useGetInvoicesQuery,
  useDeleteInvoicesMutation,
  useAddInvoiceMutation,
  useSendInvoiceEmailMutation,
  useGetInvoiceQuery,
  useLazyGetInvoiceQuery,
  useUpdateInvoiceMutation,
} = invoicesApi;
